import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import LicenseAddOnUpsertDialog from "@/v2-backoffice-client/license/addOns/catalog/LicenseAddOnUpsertDialog"
import type { AddOnCatalogFragment } from "@/v2-backoffice-client/license/addOns/catalog/__types__/license.addOn.catalog.fragment"

export type LicenseAddOnUpsertMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  addOn: AddOnCatalogFragment
}

// The board row menu's trigger for the add-on edit dialog (create goes
// through the board toolbar's New Add-on button, same dialog without an
// add-on).
function LicenseAddOnUpsertMenuItem(props: LicenseAddOnUpsertMenuItemProps) {
  const { addOn, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="edit"
        data-feature-code="UI_BackofficeAddOn_Row_Edit"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update Add-on"}
      </ActionMenu.Item>

      <LicenseAddOnUpsertDialog
        addOn={addOn}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default LicenseAddOnUpsertMenuItem
